module.exports = __webpack_public_path__ + "static/media/detail-banner2.03912a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/detail-banner2.png
// module id = 750
// module chunks = 0